import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { RouterModule } from "@angular/router";
import { FormsModule } from "@angular/forms";
import {
  MatButtonModule,
  MatChipsModule,
  MatIconModule
} from "@angular/material";
import {
  NgbAccordionModule,
  NgbDropdownModule,
  NgbTooltipModule
} from "@ng-bootstrap/ng-bootstrap";

import { SharedPipesModule } from "../pipes/shared-pipes.module";

import { InputNameDirective, PhoneNumberDirective } from "./../directives";

import { SharedComponentsModule } from "./../components";
import { AutoTabDirective } from "../directives/auto-tab.directive";
import { NumbersOnlyDirective } from "../directives/numbers-only.directive";
import { SessionService } from "app/shared/services/session";
import { EqualValidator } from "../validators/equal-validator.directive";
import { NgxPaginationModule } from "ngx-pagination";
import {PreviousRouteService} from "../services/previous-route";
import {DobDirective} from "../directives/dob.directive";

@NgModule({
  imports: [
    CommonModule,
    SharedComponentsModule,
    RouterModule,
    SharedPipesModule
  ],
  exports: [
    // Modules
    CommonModule,
    SharedComponentsModule,
    RouterModule,
    FormsModule,
    NgbDropdownModule,
    MatButtonModule,
    MatIconModule,
    MatChipsModule,
    NgbAccordionModule,
    NgbTooltipModule,
    SharedPipesModule,
    NgxPaginationModule,

    // Directives
    InputNameDirective,
    PhoneNumberDirective,
    DobDirective,
    AutoTabDirective,
    NumbersOnlyDirective,
    // Pipes
    EqualValidator
  ],
  declarations: [
    PhoneNumberDirective,
    InputNameDirective,
    DobDirective,
    AutoTabDirective,
    NumbersOnlyDirective,
    EqualValidator
  ],
  providers: [SessionService, PreviousRouteService]
})
export class SharedModule {}



// WEBPACK FOOTER //
// ./src/app/shared/modules/shared.module.ts